import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { withRouter } from '@piconetworks/router-adapter'

import Wizard from 'common/modules/wizard'
import { getNavigateBackButton } from 'common/pkgs/WizardNavigation'

import OfferOptions from './OfferOptions'

const InjectedOfferOptions = ({ router }) => {
    const wizardTypes = useSelector((state) => Wizard.selectors.wizardTypes(state))
    const popupId = useSelector((state) => Wizard.selectors.thisWizardPopupId({ state, router }))
    const productOptionId = useSelector(
        (state) => Wizard.selectors.thisWizardProductOptionId({
            state,
            router,
        }),
    )

    const backButton = getNavigateBackButton({ wizardTypes, popupId, router })

    return (
        <OfferOptions
            productOptionId={productOptionId}
            onBackButtonClick={backButton.onClick}
            renderBackButton={backButton.shouldRender}
        />
    )
}

InjectedOfferOptions.propTypes = {
    router: PropTypes.any.isRequired,
}

export default withRouter(InjectedOfferOptions)
